import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { useWindowScrollDirection } from '../../../../hooks/useWindowScrollDirection';
import { useDoesWindowScrollMeetsCriteria } from '../../../../hooks/useDoesWindowScrollMeetsCriteria';
import { theme } from '../../../../domain/theme';
import { LogoMenuItem } from './components/LogoMenuItem';
import { LinksMenuItemDesktop } from './components/LinksMenuItemDesktop';
import { LinksMenuItemHandheld } from './components/LinksMenuItemHandheld';
import { SearchMenuItem } from './components/SearchMenuItem';
import { HamburgerMenuItem } from './components/HamburgerMenuItem';

// Criteria for useDoesWindowScrollMeetsCriteria should be a constant
// function to avoid passing a new function every time this components re-renders
let isGoingUp = false;
const criteria = scrollCoordinates => {
  return scrollCoordinates.y > (isGoingUp ? 31 : 81);
};

export const MainNavigation = ({ content }) => {
  const { y: directionY } = useWindowScrollDirection();

  isGoingUp = directionY === 'up';
  const isFixed = useDoesWindowScrollMeetsCriteria(criteria);
  const isSticky = isGoingUp && isFixed;

  const styles = {
    container: css`
      padding-top: ${isFixed ? 50 : 0}px;
    `,
    nav: css`
      height: 50px;
      max-height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      top: 0;
      left: 0;
      background-color: #fff;
      border-bottom: 1px solid #f2f2f2;
    `,
    fixedNav: css`
      position: fixed;
      z-index: 10;
      top: -50px;
      left: 0;
      width: 100%;
      transition:
        transform 0.35s ease-in-out,
        -webkit-transform 0.35s ease-in-out;
    `,
    stickyNav: css`
      transform: translateY(100%);
    `,
    desktopLinksContainer: css`
      display: inline-block;
      flex-grow: 2;
      display: grid;
      place-items: center;
      font-size: ${theme.font.size('s')};
      line-height: initial;
    `,
    handheldLinksContainer: css`
      position: relative;
      display: block;
      ${theme.mq.small_desktop} {
        display: none;
      }
    `
  };

  return (
    <div css={styles.container}>
      <nav
        css={[
          styles.nav,
          isFixed && styles.fixedNav,
          isSticky && styles.stickyNav
        ]}
        id="main-navigation-nav"
        data-is-sticky={isSticky}
      >
        <LogoMenuItem content={content} />
        <div css={styles.desktopLinksContainer}>
          <LinksMenuItemDesktop content={content} />
        </div>
        <SearchMenuItem />
        <HamburgerMenuItem />
      </nav>
      <nav css={styles.handheldLinksContainer}>
        <LinksMenuItemHandheld content={content} />
      </nav>
    </div>
  );
};

MainNavigation.propTypes = {
  content: PropTypes.objectOf(PropTypes.any).isRequired
};
